import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { Size } from './enums/size.js';
import './viedoc-icon.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Large, ...IconButtonSize } = Size;
export { IconButtonSize };
let ViedocIconButton = class ViedocIconButton extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.ariaLabel = 'Icon button';
        this.size = IconButtonSize.Medium;
    }
    render() {
        const classNames = classMap({
            'icon-button': true,
            [`icon-button--${this.size}`]: true,
        });
        return html `
      <button
        aria-label=${this.ariaLabel}
        class=${classNames}
        ?disabled=${this.disabled}
      >
        <viedoc-icon
          class="icon-button__icon"
          .name="${this.icon}"
        ></viedoc-icon>
      </button>
    `;
    }
};
ViedocIconButton.styles = [
    css `
      :host {
        --icon-button-size-small: 2rem;
        --icon-button-size-medium: 2.688rem;
      }

      .icon-button {
        box-sizing: border-box;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: none;
        cursor: pointer;
        height: var(--icon-button-size-medium);
        width: var(--icon-button-size-medium);
        padding: 0;
        color: inherit;
        background: transparent;
      }

      .icon-button:disabled {
        color: var(--color-gray-30);
        pointer-events: none;
      }

      .icon-button__icon {
        display: flex;
      }

      .icon-button--small {
        height: var(--icon-button-size-small);
        width: var(--icon-button-size-small);
      }
    `,
];
__decorate([
    property({ type: Boolean, reflect: true })
], ViedocIconButton.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], ViedocIconButton.prototype, "icon", void 0);
__decorate([
    property({ type: String, attribute: 'aria-label' })
], ViedocIconButton.prototype, "ariaLabel", void 0);
__decorate([
    property({ type: String })
], ViedocIconButton.prototype, "size", void 0);
ViedocIconButton = __decorate([
    customElement('viedoc-icon-button')
], ViedocIconButton);
export { ViedocIconButton };
